import { createTracker } from 'usage-tracker';
import { withSessionReplay } from 'usage-tracker-session-replay';
import { BUTTON_HOVER_EVENT_NAME, DOCUMENT_DESCRIPTION_EVENT_NAME, DOCUMENT_INTERACTION_EVENT_NAME, DOCUMENTS_NAMESPACE, UPLOAD_FILE_EVENT_NAME } from './events';
import { SHARE_PRIVATE, SHARE_SPECIFIC, SHARE_EVERYONE } from './actions';
import * as SharingOptionTypes from 'sales-content-partitioning/constants/SharingOptionTypes';
import { makeUuid } from 'usage-tracker-core/common/helpers';
let tracker;
const uuid = makeUuid();
export const initTracker = ({
  isPublic = false
} = {}) => {
  if (tracker) {
    return tracker;
  }
  const options = {
    standalone: true
  };
  if (isPublic) {
    options.allowUnauthed = true;
    options.properties = {
      deviceId: uuid
    };
  }
  tracker = withSessionReplay(createTracker(options));
  return tracker;
};
export const resetTracker = () => {
  tracker = undefined;
};
export const track = (namespace, event, eventProps = {}) => {
  if (!tracker) {
    throw new Error('Tracker has not been initialized');
  }
  const {
    screen = 'index'
  } = eventProps;
  tracker.track(namespace, event, Object.assign({
    screen
  }, eventProps));
};
export const trackInteraction = (action, screen) => track(DOCUMENTS_NAMESPACE, DOCUMENT_INTERACTION_EVENT_NAME, {
  action,
  screen
});
export const trackHover = ({
  action,
  type
}) => track(DOCUMENTS_NAMESPACE, BUTTON_HOVER_EVENT_NAME, {
  action,
  type
});
export const trackUpload = ({
  action,
  source
}) => track(DOCUMENTS_NAMESPACE, UPLOAD_FILE_EVENT_NAME, {
  action,
  source
});
export const trackDescriptionInteraction = ({
  action
}) => track(DOCUMENTS_NAMESPACE, DOCUMENT_DESCRIPTION_EVENT_NAME, {
  action
});
export const trackPermissionSave = ({
  sharingOption
}) => {
  let action;
  switch (sharingOption) {
    case SharingOptionTypes.PRIVATE:
      action = SHARE_PRIVATE;
      break;
    case SharingOptionTypes.SPECIFIC:
      action = SHARE_SPECIFIC;
      break;
    case SharingOptionTypes.EVERYONE:
    default:
      action = SHARE_EVERYONE;
  }
  trackInteraction(action);
};